<h3 mat-dialog-title>{{title}}</h3>
<mat-dialog-content>
  <div class="theme-container w-100 flex-col">
    <div class="flex-col w-100">
      <div class="pb-2 w-100" color="primary">{{message}}</div>
      <div>
        <ol class="ml-4 w-100">
          <li>Premier Integration:&nbsp;{{premierPartnerName}} - {{premierServiceProductType}}</li>
          <li>moov configuration:&nbsp;{{moovConfiguration.filenameStartsWith}} ({{moovConfiguration.filenameContains}})</li>
          <li>Client name:&nbsp;{{client.name}}</li>
        </ol>
      </div>
    </div>
    @if (!hideParameterForm) {
    <div class="pt-2 flex-col">
      <div class="pb-2 w-100" color="primary">By default, detamoov will process any outstanding items <b>unless</b> you
        define a specific set of ID values below to process.</div>
    </div>
    <div class="mb-3 flex-col">
      <form [formGroup]="parameterForm">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>{{idsToProcessName}}</mat-label>
          <input class="w-100" matInput placeholder="{{idsToProcessName}} (optional)" formControlName="ids"
            autocomplete="off">
          <mat-hint>Enter a comma delimited list of IDs to explicitly process. Example: 7,8,9. If left blank, any
            outstanding items will be processed for this premier integration.</mat-hint>
        </mat-form-field>
         <div (click)="onAdvancedOptionsClick()" class="options-header mt-4">
          <span class="caret" [class.rotated]="advancedOptionsExpanded">></span>
          Advanced Options
        </div>
        <div class="advanced-options" [class.expanded]="advancedOptionsExpanded" [class.collapsed]="!advancedOptionsExpanded">
          <div class="w-100 flex-col">
              <span>Process on error</span>
              <span class="hint-text d-block">Mark as processed if an error occurs. Items processed with errors will not be automatically executed again</span>
            </div>
          <mat-slide-toggle color="primary" formControlName="processedOnError"></mat-slide-toggle>
        </div>
      </form>
    </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="mt-3 p-2 w-100 flex-row justify-end items-center">
    <a mat-button class="dialog-btn" color="primary" (click)="onCancelClick()"><span class="text-bold">{{cancelButtonText}}</span></a>
    <a mat-button class="dialog-btn" color="primary" (click)="onExecuteClick()" [disabled]="!canSubmit"><span class="text-bold">{{executeButtonText}}</span></a>
  </div>
</mat-dialog-actions>